import { AnalyticsEventName } from './constants';
import { trackEvent } from './utils';

export interface NonPromoEvent {
  block_name?: string;
  block_type?: string;
  block_id?: string;
}

export const trackViewOnboardingEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.ViewOnboarding,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};

export const trackSaveOnboardingEvent = (nonPromo: NonPromoEvent) => {
  if (nonPromo) {
    trackEvent({
      eventName: AnalyticsEventName.SaveOnboarding,
      parameters: {
        block_name: nonPromo.block_name ?? '',
        block_type: nonPromo.block_type ?? '',
        block_id: nonPromo.block_id ?? ''
      }
    });
  }
};
